import { createContext, useContext, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

const NavigationContext = createContext("PUSH");

export const NavigationProvider = ({ children }) => {
    const history = useHistory();
    const lastIndex = useRef(history.index);
    const [direction, setDirection] = useState("PUSH");

    history.listen((location, action) => {
        setDirection(action);

        lastIndex.current = history.index;
    });

    return (
        <NavigationContext.Provider value={direction}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigationDirection = () => useContext(NavigationContext);
